import React from "react";
import { Box, Stack } from "@mui/material";
import Detail from "./detail";
import { isArray } from "lodash";
import { v4 } from "uuid";
import { useKitchenContext } from "../KitchenPage";

function Right() {
  const { chebiens } = useKitchenContext();

  return (
    <Box sx={{ py: 2, height: "100%", overflow: "auto" }}>
      <Stack gap={1}>
        {isArray(chebiens) &&
          chebiens.map((item) => {
            return <Detail key={v4()} data={item} />;
          })}
      </Stack>
    </Box>
  );
}

export default Right;
